import React from "react";
import { useRecoilValue } from "recoil";
import { authProfile } from "../recoilStates";
import { useNavigate } from "react-router-dom";

const NotAuthorized = ({children}) => {
  const userProfile = useRecoilValue(authProfile);
  const navigate = useNavigate();
  if (!userProfile){
    navigate('/authentication/sign-in')
  }
  return children;
};

export default NotAuthorized;
